
<ng-container *ngIf="photo">
<div class="border text-center" style="margin-bottom: 25px;margin-left: 25px;height:175px;" *ngIf="photo">
    <p>{{ photo.original_filename }}</p>
    <mat-progress-spinner *ngIf="!imageSrc" class="spinner" mode="indeterminate" diameter="100"></mat-progress-spinner>
    <img  *ngIf="imageSrc" [src]="imageSrc" alt="{{photo.original_filename}}">
        <p class="photolinks">
        <a href="/assets/1019_20190308_114216792.jpg" download=""><mat-icon>cloud_download</mat-icon></a>
        <a href=""><mat-icon style="color: red;">delete</mat-icon></a>
    </p>
</div>
</ng-container>
